/*
 * Menu principal sur une seule ligne (réglage « Menu sur une seule ligne » de l'en-tête).
 * Mesure la largeur naturelle des liens et réduit leur taille juste ce qu'il faut pour tenir
 * dans la ligne, sans jamais passer sous la taille minimale choisie dans l'éditeur.
 */
(function () {
  var frame;

  function fit() {
    var nav = document.querySelector('#NavStandard[data-nav-fit]');
    if (!nav) return;

    var list = nav.querySelector('.nav--level-two .menu__items');
    if (!list) return;

    nav.style.setProperty('--nav-fit', '1');
    if (window.innerWidth < 1024) return;

    var items = list.querySelectorAll(':scope > .menu__item');
    var needed = 0;
    items.forEach(function (item) {
      needed += item.getBoundingClientRect().width;
    });

    var available = list.clientWidth;
    if (!needed || needed <= available) return;

    var link = list.querySelector('.navlink--toplevel');
    var base = link ? parseFloat(getComputedStyle(link).fontSize) : 16;
    var min = parseFloat(nav.getAttribute('data-nav-fit-min')) || 11;
    var scale = Math.max(min / base, (available / needed) * 0.985);

    nav.style.setProperty('--nav-fit', scale.toFixed(3));
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fit);
  }

  window.addEventListener('resize', schedule);
  document.addEventListener('theme:resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule);
  }
  schedule();
})();
